/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Secure_Desc6Inputs */

const en_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposed keys, open buckets and injection risks closed before launch.`)
};

const ar_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المفاتيح المكشوفة والحاويات المفتوحة ومخاطر الحقن تغلق قبل الإطلاق.`)
};

const bn_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খোলা কী, খোলা বাকেট আর ইনজেকশন ঝুঁকি লঞ্চের আগেই বন্ধ।`)
};

const de_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Schlüssel, offene Buckets und Injektionsrisiken werden vor dem Start geschlossen.`)
};

const es_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claves expuestas, buckets abiertos y riesgos de inyección cerrados antes del lanzamiento.`)
};

const fr_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clés exposées, buckets ouverts et risques d'injection fermés avant le lancement.`)
};

const pt_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaves expostas, buckets abertos e riscos de injeção fechados antes do lançamento.`)
};

const zh_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暴露的密钥、公开的存储桶和注入风险，上线前全部关闭。`)
};

const tr_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açık anahtarlar, açık kovalar ve enjeksiyon riskleri lansmandan önce kapatılır.`)
};

const ru_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытые ключи, открытые бакеты и риски инъекций закрываются до запуска.`)
};

const pl_svc_ai_app_rescue_secure_desc6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odsłonięte klucze, otwarte buckety i ryzyka iniekcji zamknięte przed startem.`)
};

/**
* | output |
* | --- |
* | "Exposed keys, open buckets and injection risks closed before launch." |
*
* @param {Svc_Ai_App_Rescue_Secure_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_secure_desc6 = /** @type {((inputs?: Svc_Ai_App_Rescue_Secure_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Secure_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_secure_desc6(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_secure_desc6(inputs)
	return en_svc_ai_app_rescue_secure_desc6(inputs)
});
export { svc_ai_app_rescue_secure_desc6 as "svc_ai-app-rescue_SECURE_desc" }